import { AxiosRequestConfig } from 'axios'
import { roundToTwoDecimals } from 'utils/number.ts'
import { getAxiosRequestConfigBoltBackend } from 'utils/request.ts'
import { Methods } from 'types/request.ts'
import { ServiceContractElectricity, ServiceContractGas } from '@boltenergy-be/shared'

/**
 * Generates the bill shock axios request config for the given data
 *
 * @param {string} billingContractId
 * @param {string} email
 * @param {ServiceContractElectricity} electricityContract
 * @param {ServiceContractGas} gasContract
 * @returns {AxiosRequestConfig}
 */
export const generateBillShockAxiosRequestConfig = (
  billingContractId: string,
  email: string,
  electricityContract: ServiceContractElectricity,
  gasContract?: ServiceContractGas
): AxiosRequestConfig => {
  const data = {
    email,
    instalments: [
      {
        contractId: electricityContract.contractNumber,
        instalment: roundToTwoDecimals(Number(electricityContract.detail.instalment))
      },
      ...(gasContract
        ? [
            {
              contractId: gasContract.contractNumber,
              instalment: roundToTwoDecimals(Number(gasContract.detail.instalment))
            }
          ]
        : [])
    ]
  }

  return getAxiosRequestConfigBoltBackend(Methods.POST, `/resources/billing-contracts/${billingContractId}/bill-shock`, data)
}
